import { ICertificate, ISignatureInfo } from "./ISignatureInfo";

export interface ICryptographicInfo {
    readonly signatureInfo: ISignatureInfo;
    readonly encryptionInfo?: IEncryptionInfo;
}

export interface IEncryptionInfo {
    readonly encrypted: boolean;
    readonly certificate: ICertificate;
    time: Date; //neni readonly, protože se musí stejně ručně instnacovat ze stringu v metodě, která načíta data ze serveru
    readonly providerType: string;
    readonly providerVersion: string;
    readonly algorithm: string;
    readonly certificateBase64: string;
}
